export function ApplicationNewOverview() {
  return (
    <div className="space-y-4 text-sm vscode-text-secondary">
      <p className="vscode-text-tertiary">
        A strong <strong className="vscode-text-primary">application record</strong> ties a{' '}
        <strong className="vscode-text-primary">candidate</strong> to an <strong className="vscode-text-primary">open job</strong> under the
        correct <strong className="vscode-text-primary">client</strong>, with clear <strong className="vscode-text-primary">internal notes</strong>{' '}
        for your team (fit, risks, next steps) — similar to submission packets in ATS / VMS tools.
      </p>
      <ol className="list-decimal list-inside space-y-2 vscode-text-tertiary border vscode-border rounded-xl p-4 bg-[color-mix(in_srgb,var(--vscode-bg-tertiary)_30%,transparent)]">
        <li>
          <strong className="vscode-text-primary">Details:</strong> pick candidate, client (filters jobs), and open role. Client auto-fills from the job when possible.
        </li>
        <li>
          <strong className="vscode-text-primary">Templates:</strong> drop in structured internal note starters (priority client, contract, referral, etc.).
        </li>
        <li>
          <strong className="vscode-text-primary">AI assistant:</strong> Llama drafts rationale, risks, or client-ready bullets into internal notes — review before submit.
        </li>
        <li>
          Optionally <strong className="vscode-text-primary">assign</strong> an owner; submit to create the pipeline card (status starts as Submitted).
        </li>
      </ol>
    </div>
  );
}
